import { TeamDashboardAPI } from 'api';
import { TInfiniteQuery, TQuery } from 'api/api.types';
import { TeamRequestList } from 'api/team-dashboard/team-dashboard.types';
import { useInfiniteQuery, useQuery, useQueryClient } from 'react-query';

export const useGetDashboardFilterEnums = () => {
  return useQuery(
    ['team-dashboard-filter-enums'],
    () => TeamDashboardAPI.getTeamDashboardFilterEnums(),
    {
      staleTime: 0
    }
  );
};

export const useTeamRequests = ({ args, ...config }: TInfiniteQuery = {}) => {
  const queryClient = useQueryClient();

  const { viewId, ...rest } = args || {};

  const queryFn = async ({ pageParam = 1 }) => {
    const { items, ...headers } = await TeamDashboardAPI.getTeamRequestsList(
      { ...rest, pageNumber: pageParam },
      viewId
    );

    queryClient.setQueryData(
      ['team-requests-headers', { id: args?.id, viewId: args?.viewId }],
      headers
    );

    return items;
  };

  return useInfiniteQuery(['team-requests', args], queryFn, {
    staleTime: 1000 * 60 * 5,
    getNextPageParam: (_, allPages) => allPages.length + 1,
    keepPreviousData: true,
    refetchInterval: 1000 * 60 * 5,
    cacheTime: 0,
    ...config
  });
};

export const useTeamRequestsExport = ({ args, ...config }: TQuery<TeamRequestList[]> = {}) => {
  const queryClient = useQueryClient();

  const { viewId, ...rest } = args ?? {};

  const queryFn = async (): Promise<TeamRequestList[]> => {
    const { items, ...headers } = await TeamDashboardAPI.getRequestExport(
      {
        ...rest,
        pageNumber: 1
      },
      viewId
    );

    queryClient.setQueryData('team-requests-export-headers', headers);

    return items;
  };

  return useQuery<TeamRequestList[], Error>(['team-requests-export', args], queryFn, {
    staleTime: 1000 * 60 * 5,
    enabled: false,
    cacheTime: 0,
    ...config
  });
};
